// Header del Dashboard JMA AFAC.
//
// Logos: jma-cybersec-horizontal.png (alto 42px, proporción canónica
// 2.152:1) + afac.png (alto 40px). Cuando hay sesión activa el avatar se
// transforma en un menú de cuenta con dropdown (AccountMenu).

import { html } from 'htm/preact'

import { AccountMenu } from './AccountMenu.js'
import { RefreshButton } from './RefreshButton.js'

export function Header({ user }) {
  return html`
    <header class="layout__header header" role="banner">
      <div class="header__brand">
        <img
          class="header__logo-jma"
          src="/logos/jma-cybersec-horizontal.png"
          alt="JMA CyberSec"
        />
        <span class="header__title">Dashboard JMA AFAC</span>
      </div>
      <div class="header__right">
        <img
          class="header__logo-afac"
          src="/logos/afac.png"
          alt="AFAC"
        />
        ${user ? html`<${RefreshButton} />` : null}
        ${user
          ? html`<${AccountMenu} user=${user} />`
          : html`
              <span
                class="header__avatar"
                aria-label="Sesión sin iniciar"
                title="Sesión sin iniciar"
              >--</span>
            `}
      </div>
    </header>
  `
}
